import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type ReCaptchaV2Store } from '../store/reCaptchaV2Store'

export const ReCaptchaV2Context = createContext<ReCaptchaV2Store | null>(null)

export const useReCaptchaV2Context = () => {
  const context = useContext(ReCaptchaV2Context)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ReCaptchaV2Context')

  return context
}

type IProviderReCaptchaV2Props = {
  value: ReCaptchaV2Store
  children: ReactNode
}

export const ProviderReCaptchaV2: FC<IProviderReCaptchaV2Props> = ({ value, children }) => {
  return <ReCaptchaV2Context.Provider value={value}>{children}</ReCaptchaV2Context.Provider>
}
